
import state from './../../zviz2/zviz/state';
import {Controller as GroupController} from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/textbox';
import PanelBlueBlueprint from './../elements/panel-blue';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
import {styleText} from './../../styles';
//import {LifeCycle} from './../zviz2/zviz/cycle';


let BlueprintChild = {
    type: GroupController,
    properties: {
        style: { 

         },
    },
    events: {  },
    children: [ 
        
        extend({
            properties: {
                html: '<strong><em>i</em>-eval Discovery</strong> provides public access to all planned and completed evaluation reports, together with related recommendations, lessons learned, good practices, summaries, and management responses. In addition ILO staff users can access the <strong><a href="https://ievalassistance.azurewebsites.net/" target="_blank">AI&nbsp;Assistant</a></strong> to obtain source-cited answers to questions concerning evaluation findings across thematic, geographical, and time-bound issues.',
                style: extend({
                    marginBottom: '10px',
                    fontSize: '12pt'
                }, styleText)
            }
        }, TextBox),
    ]
}

let Blueprint = extend({
    properties: {
        data: {title: 'About'},
    },
    private: {
        children: [ cloneObject(BlueprintChild) ]
    }
}, PanelBlueBlueprint);

export default Blueprint;
export {Blueprint};
